import Head from "next/head";
import WizardHeader from "./wizardHeader";

export default function Layout({ children, title, headerTitle }) {
  return (
    <>
      <Head>
        <title>{title}</title>
      </Head>

      <div className="flex flex-col  bg-gray-50 h-screen  overflow-hidden">
        <WizardHeader
          headline={headerTitle}
          blockLiveHelp={true}
          exitHref="/"
        />
        <div className=" flex-1 overflow-y-auto">
          <div>
            <div className="relative "> {children}</div>
          </div>
        </div>
      </div>
    </>
  );
}
